<div class="flag-input" [ngClass]="{invalid: invalid}">
  <div id="zip-code-flag-btn" class="dropdown-button" (click)="isOpen = !isOpen">
    <img class="flag-size" style="height: 16px;" src="../../../../assets/svgs/{{flagOptions[selectedOption].icon}}.svg" alt="{{flagOptions[selectedOption].icon}}">
    <div class="svg-div">
      <img class="img" [ngClass]="{'icon-revert': isOpen}" src="../../../../assets/svgs/dropdown_arrow_ico.svg"  label="arrow-icon" alt="dropdown-arrow">
    </div>
  </div>
  <input id="zip-code-flag-input" placeholder="{{placeholder}}" type="text" mask="{{flagOptions[selectedOption].mask}}" [(ngModel)]="value" (click)="isOpen = false"> 

  <div class="dropdown-box" *ngIf="isOpen">
    <div class="dropdown-item" *ngFor="let flag of flagOptions; let i = index" (click)="changeFlag(i)">
      <img class="flag-size" style="height: 16px;" src="../../../../assets/svgs/{{flag.icon}}.svg" alt="{{flag.icon}}">
      <p class="item-label">{{flagOptions[selectedOption].country}}</p>
    </div>
  </div>
</div>